import React from 'react';
import { getSurfaceClassName } from '../utils/cardSurface';
import { normalizePatternId } from '../utils/cardPatterns';

/**
 * @param {boolean} allowPhoto — фото только в списке кошелька (фон регистрации)
 */
const CardBackground = ({
  mainColor,
  imageUrl,
  cardStyle = 'plastic',
  backgroundPattern = 'solid',
  allowPhoto = false,
  className = '',
}) => {
  const hasPhoto = allowPhoto && !!imageUrl;
  const pattern = normalizePatternId(backgroundPattern);
  const showPattern = !hasPhoto && pattern !== 'solid';

  return (
    <div className={`card-bg ${hasPhoto ? 'card-bg--photo' : 'card-bg--color'} ${className}`} aria-hidden="true">
      <div className="card-bg-color" style={{ backgroundColor: mainColor || '#4f6ef7' }} />
      {hasPhoto && (
        <img
          className="card-bg-photo"
          src={imageUrl}
          alt=""
          draggable="false"
          loading="eager"
          decoding="async"
        />
      )}
      {showPattern && (
        <div className={`card-bg-pattern card-bg-pattern--${pattern}`} />
      )}
      {!hasPhoto && (
        <div className={`card-bg-shine ${getSurfaceClassName(cardStyle)}`} />
      )}
    </div>
  );
};

export default CardBackground;
